(function () {
  'use strict';

  var DISMISS_KEY = 'upsell_dismissed';
  var cartState = { productIds: [] };
  var currentConfig = null;

  // ── Format money using theme's currency format ───────────
  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
    var dollars = cents / 100;
    var amount = dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2);
    return fmt
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100));
  }

  function getDismissed() {
    try { return JSON.parse(sessionStorage.getItem(DISMISS_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveDismissed(ids) {
    try { sessionStorage.setItem(DISMISS_KEY, JSON.stringify(ids)); } catch (e) {}
  }

  function dismissVariant(variantId) {
    var ids = getDismissed();
    if (ids.indexOf(variantId) === -1) ids.push(variantId);
    saveDismissed(ids);
  }

  function updateCartCount(itemCount) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = itemCount; });
    document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) { el.textContent = itemCount; });
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', itemCount > 0);
    });
  }

  // ── Fetch fresh config from Section Rendering API ────────
  function fetchConfig() {
    return fetch('/?sections=upsell-cart-data', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['upsell-cart-data'] || '';
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var el = tmp.querySelector('#upsell-cart-data');
        if (!el) return null;
        return JSON.parse(el.textContent);
      })
      .catch(function () { return null; });
  }

  // ── Render suggestions into cart drawer ──────────────────
  function renderSuggestions(config) {
    var container = document.getElementById('upsell-cart-drawer');
    if (!container || !config) return;

    var dismissed = getDismissed();
    var cartProductIds = cartState.productIds;
    var cartTotalCents = config.cartTotalCents || 0;

    var filtered = (config.candidates || []).filter(function (c) {
      return cartProductIds.indexOf(c.productId) === -1 &&
             dismissed.indexOf(c.variantId) === -1;
    });

    filtered = filtered.slice(0, config.max || 3);

    if (filtered.length === 0) {
      container.innerHTML = '';
      return;
    }

    var html = '<p class="upsell-cart__heading">' + escHtml(config.heading) + '</p>';

    filtered.forEach(function (c) {
      // ── Discount calculation ───────────────────────────
      var discountActive = false;
      var discountedCents = 0;
      var savingsCents = 0;

      if (c.discountEnabled && c.discountValue > 0 && c.priceRaw) {
        var minCartCents = (c.discountMinCart || 0) * 100;
        if (minCartCents === 0 || cartTotalCents >= minCartCents) {
          discountActive  = true;
          discountedCents = Math.round(c.priceRaw * (1 - c.discountValue / 100));
          savingsCents    = c.priceRaw - discountedCents;
        }
      }

      // ── Reason text ────────────────────────────────────
      var reasonHtml = '';
      if (config.showReason && c.reason) {
        var reasons;
        try { reasons = JSON.parse(c.reason); } catch (e) { reasons = null; }
        var reasonText = Array.isArray(reasons) ? (reasons[c.reasonIndex] || '') : '';
        if (reasonText) {
          reasonHtml = '<p class="upsell-cart__reason">' + escHtml(reasonText) + '</p>';
        }
      }

      // ── Image ──────────────────────────────────────────
      var imgHtml = c.image
        ? '<img src="' + escAttr(c.image) + '" alt="' + escAttr(c.imageAlt) + '" class="upsell-cart__img" loading="lazy" width="52" height="52">'
        : '';

      // ── Price display ──────────────────────────────────
      var priceHtml;
      if (discountActive) {
        priceHtml = '';
        if (config.showDiscountOriginalPrice) {
          priceHtml += '<span class="product__price product__price--compare upsell-cart__price-compare">' + escHtml(c.price) + '</span>';
        }
        priceHtml += '<span class="on-sale upsell-cart__price">' + formatMoney(discountedCents) + '</span>';
        if (config.showDiscountSavings) {
          priceHtml += '<span class="upsell-cart__save tag">Save ' + formatMoney(savingsCents) + '</span>';
        }
      } else {
        priceHtml = '<span class="upsell-cart__price">' + escHtml(c.price) + '</span>';
      }

      // ── Action button ──────────────────────────────────
      var addLabel = discountActive ? 'Add &mdash; Save ' + formatMoney(savingsCents) : 'Add';
      var actionHtml = c.singleVariant
        ? '<button type="button" class="btn btn--secondary btn--small upsell-cart__add" data-upsell-add data-variant-id="' + c.variantId + '">' + addLabel + '</button>'
        : '<a href="' + escAttr(c.url) + '" class="btn btn--secondary btn--small upsell-cart__add">View</a>';

      // ── Discount badge ─────────────────────────────────
      var badgeHtml = discountActive && c.discountLabel
        ? '<span class="upsell-cart__disc-badge tag">' + escHtml(c.discountLabel) + '</span>'
        : '';

      // ── Dismiss ────────────────────────────────────────
      var dismissHtml = config.allowDismiss
        ? '<button type="button" class="upsell-cart__dismiss" data-upsell-dismiss data-variant-id="' + c.variantId + '">No thanks</button>'
        : '';

      html +=
        '<div class="upsell-cart__item" data-upsell-item="' + c.variantId + '">' +
          '<a href="' + escAttr(c.url) + '" class="upsell-cart__img-wrap" tabindex="-1">' + imgHtml + '</a>' +
          '<div class="upsell-cart__info">' +
            '<a href="' + escAttr(c.url) + '" class="upsell-cart__title">' + escHtml(c.title) + '</a>' +
            reasonHtml +
          '</div>' +
          '<div class="upsell-cart__right">' +
            priceHtml +
            badgeHtml +
            actionHtml +
            dismissHtml +
          '</div>' +
        '</div>';
    });

    container.innerHTML = html;
    bindCartButtons(config);
  }

  // ── Refresh config from server then re-render ─────────────
  function refreshAndRender() {
    fetchConfig().then(function (config) {
      if (!config) return;
      currentConfig = config;
      cartState.productIds = config.cartProductIds || [];
      renderSuggestions(config);
    });
  }

  // ── Bind add + dismiss buttons ───────────────────────────
  function bindCartButtons(config) {
    var container = document.getElementById('upsell-cart-drawer');
    if (!container) return;

    container.querySelectorAll('[data-upsell-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = parseInt(this.getAttribute('data-variant-id'), 10);
        if (!variantId) return;
        var origHTML = this.innerHTML;
        this.textContent = '\u2026';
        this.disabled = true;
        var self = this;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function () {
            var item = self.closest('[data-upsell-item]');
            if (item) item.remove();
            document.dispatchEvent(new CustomEvent('cart:build'));
            return fetch('/cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            return fetchConfig();
          })
          .then(function (freshConfig) {
            if (freshConfig) {
              currentConfig = freshConfig;
              cartState.productIds = freshConfig.cartProductIds || [];
            }
            renderSuggestions(currentConfig);
          })
          .catch(function () {
            self.innerHTML = origHTML;
            self.disabled = false;
          });
      });
    });

    container.querySelectorAll('[data-upsell-dismiss]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = parseInt(this.getAttribute('data-variant-id'), 10);
        dismissVariant(variantId);
        var item = this.closest('[data-upsell-item]');
        if (item) item.remove();
        if (!document.querySelector('#upsell-cart-drawer [data-upsell-item]')) {
          document.getElementById('upsell-cart-drawer').innerHTML = '';
        }
      });
    });
  }

  function escHtml(str) {
    return String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function escAttr(str) {
    return String(str || '').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // ── Init ─────────────────────────────────────────────────
  function init() {
    refreshAndRender();

    document.addEventListener('click', function (e) {
      if (e.target.closest('.js-drawer-open-cart') || e.target.closest('[data-cart-toggle]')) {
        refreshAndRender();
      }
    });

    document.addEventListener('upsell:cart-updated', function () {
      refreshAndRender();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
